import { Pipe, PipeTransform } from "@angular/core";
import { Observable, interval, map, startWith, takeWhile } from "rxjs";

@Pipe({
  name: 'timer',
  standalone: true
})
export class TimerPipe implements PipeTransform {
  transform(expirationDate: Date): Observable<string> {
    return interval(1000).pipe(
      startWith(0),
      map(() => {
        try {
          if (!expirationDate || isNaN(expirationDate.valueOf())) {
            return '00:00:00';
          }

          const now = new Date();
          const expiration = new Date(expirationDate);
          const timeDifference = expiration.getTime() - now.getTime();

          if (timeDifference <= 0) {
            return '00:00:00';
          }

          const hours = Math.floor(timeDifference / (1000 * 60 * 60));
          const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

          return `${this.padZero(hours)}:${this.padZero(minutes)}:${this.padZero(seconds)}`;
        } catch ( _ ) {
          return '00:00:00';
        }
      }),
      takeWhile(value => value !== '00:00:00', true)
    );
  }

  private padZero(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }
}
